export const BEFORE_WORKSPACE_LAYOUT_CHANGE = 'path:before-workspace-layout-change';

// A layout switch is navigation when it removes a widget containing unsaved work.
// Existing assessment confirmation owns the choice; normal layout changes stay instant.
export const changeWorkspaceLayout = (current, next, apply) => {
  const removedWidgetIds = current.filter(item => !next.some(target => target.id === item.id)).map(item => item.id);
  if (removedWidgetIds.length && typeof window !== 'undefined') {
    const event = new CustomEvent(BEFORE_WORKSPACE_LAYOUT_CHANGE, {
      cancelable: true, detail: { removedWidgetIds, proceed: apply },
    });
    if (!window.dispatchEvent(event)) return;
  }
  apply();
};
